import { getDrivers } from "@services";
import { FleetDriver } from "@types";
import React, { useEffect, useState } from "react";

export type TCoreContext = {
  drivers: FleetDriver[];
};

export const CoreContext = React.createContext<TCoreContext>({
  drivers: [],
});

export const CoreProvider = ({ children }: { children: React.JSX.Element }) => {
  const [drivers, setDrivers] = useState<FleetDriver[]>([]);

  const fetchDrivers = async () => {
    try {
      const response = await getDrivers();
      setDrivers(response);
    } catch (error) {
      setDrivers([]);
    }
  };

  useEffect(() => {
    fetchDrivers();
  }, []);

  return (
    <CoreContext.Provider
      value={{
        drivers,
      }}
    >
      {children}
    </CoreContext.Provider>
  );
};
